import React from 'react';
import { Helmet } from 'react-helmet-async'

const ProductEdgeFinans = () => {
   return (
      <>
         <Helmet>
            <script
               type="text/javascript"
               src="https://cdn.edgefinanslaget.se/verktygsboden.js"
            ></script>
         </Helmet>
      </>
   )
}
 
export default ProductEdgeFinans;